import React from 'react'
import { Select, TextField } from '@the-platform-group/component-library'
import { Grid } from '@the-platform-group/component-library/Layout'
import { MERGE_STATUS_OPTIONS } from '../constants'

function MergeRecordsFilters({ filters, onTermChange, onStatusChange }) {
  return (
    <Grid container alignItems="center" spacing={2}>
      <Grid item xs={3}>
        <TextField
          onChange={onTermChange}
          placeholder="Search by Platform Profile Name"
          name="term"
          value={filters.term}
          fullWidth
          size="small"
        />
      </Grid>
      <Grid item xs={2}>
        <Select
          id="merge-status-filter"
          name="status"
          variant="outlined"
          value={filters.status}
          options={MERGE_STATUS_OPTIONS}
          onChange={onStatusChange}
          size="medium"
          placeholder="Filter by Merge Status"
          allowEmpty
          margin="none"
        />
      </Grid>
    </Grid>
  )
}

export default MergeRecordsFilters
